import React, { type ReactNode } from 'react';

import './FileViewerToolbar.css';

type Props = {
  leftActions?: ReactNode[];
  rightActions?: ReactNode[];
};

export const FileViewerToolbar = ({
  leftActions = [],
  rightActions = [],
}: Props) => {
  if (leftActions.length === 0 && rightActions.length === 0) {
    return null;
  }

  return (
    <div className="FileViewerToolbar">
      {leftActions.length > 0 && (
        <div className="flex items-center gap-8">{leftActions}</div>
      )}
      {rightActions.length > 0 && (
        <div className="ml-auto flex items-center gap-8">{rightActions}</div>
      )}
    </div>
  );
};
